export default __webpack_public_path__ + "static/media/colony_2.f2b4a09f.jpg";